const yearNow = new Date().getFullYear()
const Footer = () => {
  return (
    <footer className="flex-center">Copyright © Presentation Ace 2022 - {yearNow}</footer>
  )
}

export default Footer
